import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "weekday-selector" },
    [
      _c(
        VChipGroup,
        {
          staticClass: "weekday-selector__group",
          attrs: { value: _setup.selectedWeekday, mandatory: "" },
          on: { change: _setup.handleChange },
        },
        _vm._l(_setup.weekdayTabs, function (tab) {
          return _c(
            VChip,
            {
              key: tab.value,
              staticClass: "rounded-0 ma-0 w-100",
              class: {
                primary: _setup.selectedWeekday === tab.value,
                "bg-secondary primary--text":
                  _setup.selectedWeekday !== tab.value,
              },
              attrs: { value: tab.value },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t(tab.name, _setup.options)) +
                  "\n    "
              ),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }